import { useEffect, useState } from "react";
import ApiDatabase from "../server";

// Lightweight hook that exposes the integration connection flags shipped in `getUserInfo`.
// Returns `{ peopulse, jobbiz, isLoading, hasAny }`.
const useIntegrations = () => {
  const [state, setState] = useState({
    peopulse: false,
    jobbiz: false,
    isLoading: true,
  });

  useEffect(() => {
    let cancelled = false;
    ApiDatabase.getUserInfo(
      {},
      (data) => {
        if (cancelled) return;
        const integrations = data?.user?.integrations || {};
        setState({
          peopulse: Boolean(integrations.peopulse),
          jobbiz: Boolean(integrations.jobbiz),
          isLoading: false,
        });
      },
      () => {
        if (cancelled) return;
        setState((prev) => ({ ...prev, isLoading: false }));
      }
    );
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    ...state,
    hasAny: Boolean(state.peopulse) || Boolean(state.jobbiz),
  };
};

export default useIntegrations;
